<template>
  <slot />
</template>

<script setup lang="ts">
import { onErrorCaptured } from 'vue'
import { analytics } from '@/shared/services/analytics'

onErrorCaptured((err) => {
  analytics.captureException(err, { component: 'ErrorBoundary' })
})
</script>
